import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon67: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M12.315 0C13.382 0 14.266 0.792998 14.344 1.81L14.35 1.95599L14.353 7.37701H17.295C18.942 7.37701 20.202 8.77699 19.973 10.33L19.944 10.491L18.355 17.914C18.107 19.069 17.087 19.906 15.881 19.981L15.708 19.986L12.78 19.987C11.144 19.987 9.57201 19.66 8.11801 19.116C7.71201 18.964 7.339 18.803 7 18.641V19.5C7 19.776 6.776 20 6.5 20H2.729C1.222 20 0 18.779 0 17.273V7.008C0 6.732 0.224 6.509 0.5 6.509H6.5C6.776 6.509 7 6.732 7 7.008V7.789L7.84799 7.13901L8.155 6.897L8.43701 6.668L8.664 6.47101C9.628 5.59001 10.201 4.69101 10.273 3.74701L10.28 3.54401V1.957C10.28 0.920001 11.116 0.0800049 12.164 0.00500488L12.315 0ZM6 7.508H1V17.273C1 18.227 1.774 19.001 2.729 19.001H6V7.508ZM12.315 0.998993C11.78 0.998993 11.346 1.37401 11.287 1.84601L11.279 1.94901L11.28 3.54401C11.28 4.90101 10.559 6.09402 9.33899 7.20901L9.03101 7.474L8.66199 7.772L7.63199 8.55801C7.24499 8.92501 7.02899 9.42101 7.02899 9.93701C7.02899 9.99501 7.019 10.052 7 10.104L6.99899 17.519L7.20401 17.626C7.57301 17.814 7.99699 18.003 8.46899 18.18C9.68299 18.634 10.984 18.925 12.33 18.979L12.78 18.988L15.708 18.987C16.473 18.986 17.131 18.512 17.341 17.842L17.377 17.705L18.966 10.282C19.166 9.34601 18.445 8.45699 17.434 8.38199L17.295 8.37701H13.853C13.608 8.37701 13.404 8.20001 13.361 7.96701L13.353 7.87701L13.35 1.957C13.35 1.434 12.892 0.998993 12.315 0.998993Z"
        fill="#404040"
      />
    </Icon>
  )
}
